// extracted by mini-css-extract-plugin
export default {"link":"ItemBasePersonSocialSites_link__y3tI0"};